import React from 'react'
import { Instagram, WhatsApp } from "@mui/icons-material";
import PhoneIcon from "@mui/icons-material/Phone";
import { useNavigate } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import EmailIcon from '@mui/icons-material/Email';
import Path from '../Common/Path';


export default function Footer() {
    const navigate = useNavigate()
    return (
        <div className='Footer shadow'>
            <div className="container p-2">
                <div className="row d-flex align-items-center">
                    <div className="col-12 col-md-4">
                        <div className="d-flex justify-content-center justify-content-md-start">
                            {/* Instagram */}
                            <a
                                href="https://www.instagram.com/kkmarketing.in?igsh=MXd2czZycjU3Mm50eA=="
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-danger mx-2"
                                aria-label="Instagram"
                            >
                                <Instagram />
                            </a>

                            {/* WhatsApp */}
                            <a
                                href="https://wa.me/917069566650?text=jeaco%20pv%20profile%20joining%20message"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-success mx-2"
                                aria-label="WhatsApp"
                            >
                                <WhatsApp />
                            </a>

                            {/* IndiaMART */}
                            <a
                                href="https://IndiaMART.in/WRZxgeVp"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-danger mx-2"
                                aria-label="IndiaMART"
                            >
                                <img
                                    src="/assets/IndiaMart.png"
                                    alt="IndiaMART"
                                    width="24"
                                    height="24"
                                />
                            </a>

                            <a
                                href="mailto:zeacoprofile@gmail.com?subject=Jeaco%20PV%20Profile%20Joining&body=Hello,%20I%20am%20interested%20in%20joining%20Jeaco%20PV%20profile."
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary mx-2"
                                aria-label="Email"
                            >
                                <EmailIcon />
                            </a>

                        </div>
                    </div>
                    <div className="col-12 col-md-4 mt-2">
                        <div className="d-flex justify-content-center">
                            <img src="./Logo.png" alt="" width={"30%"} />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 my-2">
                        <div className="d-flex justify-content-center justify-content-md-end gap-2">
                            <a
                                href="tel:+919537959597"
                                className="d-flex align-items-center text-decoration-none text-dark"
                                style={{ fontSize: "18px", fontWeight: "bold" }}
                            >
                                <PhoneIcon style={{ marginRight: "8px", color: "#28a745" }} />
                                +91 95379 59597
                            </a>
                            <a
                                href="tel:+919983750162"
                                className="d-flex align-items-center text-decoration-none text-dark"
                                style={{ fontSize: "18px", fontWeight: "bold" }}
                            >
                                <PhoneIcon style={{ marginRight: "8px", color: "#28a745" }} />
                                +91 99837 50162
                            </a>
                        </div>
                    </div>
                </div>
                <hr className='m-1' />
                <div className="row my-2">
                    <div className="col-6 col-md-4">
                        <div className="h4 text_main text-center">Products</div>
                        <div className="d-flex justify-content-center">
                            <ul className='m-0 p-0 d-flex flex-column'>
                                <li onClick={() => navigate(Path.furniture)} className=' my-2'><ArrowForwardIosIcon style={{ fontSize: "16px" }} />Furniture</li>
                                <li onClick={() => navigate(Path.doors)} className=' my-2'><ArrowForwardIosIcon style={{ fontSize: "16px" }} />Doors</li>
                                <li onClick={() => navigate(Path.material)} className=' my-2'><ArrowForwardIosIcon style={{ fontSize: "16px" }} />Material</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-6 col-md-4">
                        <div className="h4 text_main text-center">Navigation</div>
                        <div className="d-flex justify-content-center">
                            <ul className='m-0 p-0 d-flex flex-column'>
                                <li onClick={() => navigate(Path.home)} className=' my-2'><ArrowForwardIosIcon style={{ fontSize: "16px" }} />Home</li>
                                <li onClick={() => navigate(Path.about)} className=' my-2'><ArrowForwardIosIcon style={{ fontSize: "16px" }} />About Us</li>
                                <li onClick={() => navigate(Path.contact)} className=' my-2'><ArrowForwardIosIcon style={{ fontSize: "16px" }} />Contact Us</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="h4 text_main text-center">Address</div>
                        <div className="d-flex justify-content-center">
                            <ul className='m-0 p-0 d-flex flex-column'>
                                <li> Zenova Plast</li>
                                <li> 📍 Ahmedabad</li>
                                <li> ✅ IndiaMART Verified Supplier</li>
                                <li>GST: 24AWLPC7199M1ZW</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg_main p-2">
                <div className="">
                    © 2025 Script Scholar Technology. All Rights Reserved.
                </div>
            </div>
        </div>
    )
}
